<template>
    <div
        id="lt-yantr"
        class="advanced-calc reverse-mortgage-calc">
        <div class="container-width">
            <div class="filter-and-result">
                <div class="advanced-calc-filter">
                    <ul class="filter-inputs two-col">
                        <li v-if="QualifiedAge ==='yes'">
                            <div class="form-group">
                                <label>{{ labelAgeTitleHolder }}</label>
                                <input
                                    v-model="AgeTitleHolder"
                                    type="text"
                                    inputmode="decimal"
                                    @keypress="isNumber($event)"
                                />
                            </div>
                        </li>
                        <li>
                            <drop-down
                                v-model="PropertyType"
                                :label="labelPropertyType"
                                :options="PropertyTypeList"
                            />
                        </li>
                        <li>
                            <number-input
                                v-model="HomeValue"
                                :label="labelHomeValue"
                                :tooltip-link="tooltipHomeValue"
                                inputmode="decimal"
                            />
                        </li>
                        <li>
                            <number-input
                                v-model="MortgageBalance"
                                :label="labelMortgageBalance"
                                :tooltip-link="tooltipMortgageBalance"
                                inputmode="decimal"
                            />
                        </li>
                        <li>
                            <drop-down
                                v-model="PropertyUse"
                                :label="labelPropertyUse"
                                :options="PropertyUseList"
                            />
                        </li>
                        <li class="zip-code-input">
                            <label>{{ labelPropertyLocation }}</label>
                            <zip-code-input
                                v-model="ZipCode"
                                @input="getLocationByZip"
                            />
                            <span
                                v-show="ShowZipCodeError"
                                class="error-msg">Please enter a valid zip code.</span>
                            <div
                                v-if="TempLocData.city"
                                class="address">
                                <span class="lt4-MapPin"></span> {{ TempLocData.city + ', ' + TempLocData.state }}
                            </div>
                        </li>
                    </ul>
                    <a
                        href="javascript:void(0)"
                        class="reset-calc hidden-xs"
                        @click="resetFilter()">
                        <span class="lt-icons lt4-Refresh"></span> Reset Calculator
                    </a>
                </div>
                <div class="calculation-section">
                    <div>
                        <div v-if="Qualify === true && PropertyType !== 'MOBILEPERMANENT'">
                            <h4>Your lump sum may be as much as:</h4>
                            <label
                                class="homeprice"
                                :class="{ 'red-text': !isNegativeAmount}">${{ currencyWholeNumber(TotalMoPayment) }}</label>
                            <div class="view-free-offers">
                                <h4>We’ve found offers for this result:</h4>
                                <button
                                    class="btn btn-blue btn-arrow"
                                    type="submit"
                                    @click="redirect()">
                                    {{ DestinationButtonText }}
                                </button>
                            </div>
                        </div>
                        <div v-else>
                            <div class="view-free-offers">
                                <div v-if="PropertyType === 'MOBILEPERMANENT'">
                                    <h4>This property does not qualify for a reverse mortgage.</h4>
                                </div>
                                <div v-else>
                                    <div v-if="TempLocData.state === 'NC' && QualifiedAge === 'yes' && unformatFigure(AgeTitleHolder) >= 62">
                                        <h4>
                                            We noticed you're in North Carolina, we can help you over the phone. Please call <a
                                                href="tel:+18003513904"
                                                rel="nofollow">1-800-351-3904</a>.
                                        </h4>
                                    </div>
                                    <div v-else>
                                        <h4>Sorry, but at this time you do not qualify for a reverse mortgage, however you may qualify for a <a href="https://www.lendingtree.com/redirect/offers?id=wp-refinance">cash-out refinance</a>.</h4>
                                    </div>
                                </div>
                                <a
                                    class="btn btn-blue btn-arrow"
                                    :href="cashOutLinkOrId">{{ cashOutButtonText }}</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="DisclosureText"
                            :disclosure-tokens="DisclosureTokens"
                        />
                    </div>
                    <lt-logo v-if="ltLogo == 1">
                        <small>NMLS#1136 Terms & Conditions Apply</small>
                    </lt-logo>
                </div>
                <div class="clear-fix"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import LoanTypeList from '~/constants/loan-type-list';
    import ReverseMortgageHelper from '~/helpers/reversemortgage-calculator';
    import BaseMixin from '~/mixin/base-mixin';
    import StringFormat from '~/helpers/string-format';
    import LtLogo from '~/components/lt-logo.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import GetLocation from '~/mixin/get-geo-location';

    export default {
        components: {
            NumberInput,
            DropDown,
            LtLogo,
            AdvertisingDisclosures,
            ZipCodeInput,
        },
        mixins: [BaseMixin, GetLocation],
        props: {
            labelOneHolder: {
                default: 'Is at least one title holder 62 or older?',
            },
            labelAgeTitleHolder: {
                default: 'Age of Youngest Title Holder:',
            },
            ageTitleHolder: {
                default: 62,
            },
            labelPropertyType: {
                default: 'Type of Property:',
            },
            propertyType: {
                default: 'SINGLEFAMDET',
            },
            labelHomeValue: {
                default: 'Home Value:',
            },
            homeValue: {
                default: 400000,
            },
            tooltipHomeValue: {
                default: 'home-value',
            },
            labelMortgageBalance: {
                default: 'Mortgage Balance:',
            },
            mortgageBalance: {
                default: 0,
            },
            tooltipMortgageBalance: {
                default: 'current-balance',
            },
            labelPropertyUse: {
                default: 'Property Use:',
            },
            propertyUse: {
                default: 'OWNEROCCUPIED',
            },
            labelPropertyLocation: {
                default: 'Property Location:',
            },
            geoLocation: {
                type: Object,
                default() {
                    return {
                        zipCode: '',
                        city: '',
                        state: '',
                    };
                },
            },
            totalMoPayment: {
                default: 197312,
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            destinationLinkOrId: {
                default: 'wp-reverse',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            lendingLimit: {
                default: 679650,
            },
            interestRate: {
                default: 4,
            },
            lowestAmount: {
                default: 10000,
            },
            cashOutLinkOrId: {
                default: 'https://www.lendingtree.com/home/refinance/cash-out/',
            },
            cashOutButtonText: {
                default: 'Learn more about cash-out refinance',
            },
        },
        data() {
            return {
                AgeTitleHolder: this.ageTitleHolder,
                PropertyType: this.propertyType,
                PropertyTypeList: LoanTypeList.MortgagePropertyTypeList,
                HomeValue: this.homeValue,
                MortgageBalance: this.mortgageBalance,
                PropertyUse: this.propertyUse,
                PropertyUseList: LoanTypeList.PropertyIntentionList,
                ZipCode: '',
                ShowZipCodeError: false,
                TempLocData: {},
                TotalMoPayment: this.totalMoPayment,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                InterestRate: this.interestRate,
                LendingLimit: this.lendingLimit,
                Qualify: false,
                QualifiedAge: 'yes',
            };
        },
        computed: {
            isNegativeAmount() {
                return this.TotalMoPayment >= 0;
            },
            getFieldValues() {
                return this.InterestRate + this.LendingLimit + this.unformatFigure(this.HomeValue) + this.unformatFigure(this.MortgageBalance) + this.unformatFigure(this.AgeTitleHolder) + this.QualifiedAge + this.TempLocData.state + this.PropertyUse;
            },
            getURLParams() {
                return this.ZipCode + this.PropertyUse + this.PropertyType;
            },
        },
        watch: {
            TempLocData() {
                this.TempLocData.state = this.TempLocData !== undefined && this.TempLocData.state !== undefined ? this.TempLocData.state.trim() : '';
            },
            getFieldValues() {
                this.getPayment();
            },
            getURLParams() {
                this.setDestinationURL();
            },
            AgeTitleHolder() {
                this.AgeTitleHolder = this.unformatFigure(this.AgeTitleHolder) < 0 ? 0 : this.AgeTitleHolder;
            },
        },
        mounted() {
            this.getPayment();
            this.setDestinationURL();
        },
        methods: {
            capitalize(value) {
                if (!value) return '';

                const localData = value.toString();
                return localData.charAt(0).toUpperCase() + localData.slice(1);
            },
            currencyFilterWithPrecision(figure) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision: 2 }) : 0;
            },
            currencyWholeNumber(figure) {
                return figure > 0 ? Accounting.formatNumber(figure) : 0;
            },
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.zipCodeValidator()) {
                    this.ShowZipCodeError = false;
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            updateLocation(val) {
                val.city = val.city.toLowerCase();
                val.city = StringFormat.capitalize(val.city);
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(val) {
                this.updateLocation(val);
                this.TempLocData = val;
                if (val.err) {
                    this.ShowZipCodeError = true;
                }
            },
            resetFilter() {
                this.ZipCode = '';
                this.TempLocData = {};
                this.AgeTitleHolder = this.formatFigure(this.ageTitleHolder);
                this.PropertyType = this.propertyType;
                this.HomeValue = this.formatFigure(this.homeValue);
                this.MortgageBalance = this.formatFigure(this.mortgageBalance);
                this.PropertyUse = this.propertyUse;
                this.TotalMoPayment = this.totalMoPayment;
                this.QualifiedAge = 'yes';
                this.getPayment();
            },
            getPayment() {
                this.TotalMoPayment = ReverseMortgageHelper.getPayment(this.unformatFigure(this.HomeValue), this.unformatFigure(this.MortgageBalance), this.unformatFigure(this.AgeTitleHolder), this.ZipCode, this.InterestRate, this.LendingLimit);
                const balanceLimit = ReverseMortgageHelper.multiplyAmounts(this.LendingLimit, ReverseMortgageHelper.getLTV(this.unformatFigure(this.AgeTitleHolder), this.InterestRate));
                this.Qualify = this.unformatFigure(this.MortgageBalance) <= balanceLimit && this.unformatFigure(this.AgeTitleHolder) >= 62 && this.unformatFigure(this.AgeTitleHolder)
                    && this.TotalMoPayment > this.lowestAmount && this.QualifiedAge === 'yes' && this.TempLocData.state !== 'NC' && this.PropertyUse === 'OWNEROCCUPIED';
            },
            setDestinationURL() {
                const urlParams = `&property-type=${this.PropertyType}&property-use=${this.PropertyUse}${this.ZipCode !== '' ? `&property-zip=${this.ZipCode}` : ''}`;
                this.DestinationLinkOrId += urlParams;
            },
            isNumber(evt) {
                let result = false;
                const event = evt || window.event;
                const charCode = event.which ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    event.preventDefault();
                } else {
                    result = true;
                }
                return result;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
